import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Link, Switch, Redirect } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import CourseOption from './CourseOption';
import Register from './Register';
import PaymentType from './PaymentType';
import PaymentDetails from './PaymentDetails';
import Confirm from './Confirm';
import Complete from './Complete';
import CheckoutProgress from '../../components/CheckoutProgress';
import CheckoutServerError from '../../components/CheckoutServerError';
import logo from '../../img/branding/branding.svg';
import signatureLogo from '../../img/signature-logo.png';
import ibslLogo from '../../img/ibsl-logo.png';
import stripePower from '../../img/powered-by-stripe.png';
import fetchHelpers from '../../helpers/fetchHelpers';
import graphql from '../../helpers/graphql';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env['REACT_APP_STRIPE_PUBLIC_KEY_' + process.env.REACT_APP_ENV.toUpperCase()]);

class Checkout extends Component {
  constructor (props) {
    super(props);

    let course = {};

    if (this.props.location.state && this.props.location.state.course) {
      course = {
        id: this.props.location.state.course.id,
        title: this.props.location.state.course.title,
        type: this.props.location.state.course.type,
        duration: this.props.location.state.course.courseOptions[0].courseDurationWeeks,
        price: this.props.location.state.course.courseOptions[0].price,
        instalmentPrice: this.props.location.state.course.courseOptions[0].instalmentPrice,
        instalmentDurationMonths: this.props.location.state.course.courseOptions[0].instalmentDurationMonths,
        level: 89
      };
    }
    this.state = {
      course: course,
      courses: [],
      customer: { name: '', email: '', token: '', news: false },
      payment: { cardType: '', name: '', number: '', expiryDate: '', code: '', paymentOption: 'buyNow', paymentType: 'transfer' },
      currentStep: 1,
      redirect: false,
      serverErrorMessage: '',
      inAppPurchase: false
    };

    this.postToServer = this.postToServer.bind(this);
    this.handleStepSubmit = this.handleStepSubmit.bind(this);
    this.handleGetStarted = this.handleGetStarted.bind(this);
  }

  signupToMailingList = (customer) => {
    if (customer.news) {
      graphql.signupToMailingList(customer).then(response => {
        if (response.mailingListMutation.success) {
          console.log('signup success');
        }
      });
    }
  };

  errorResponseHandler = (state, response) => {
    // show validation / error message
    state.serverErrorMessage = response.message;
    state.redirect = true;
    switch (response.errorType) {
      case 'user':
        state.currentStep = 0;
        break;
      case 'payment':
        state.currentStep = 2;
        break;
      default:
        state.redirect = false;
        break;
    }
    return state;
  };

  async postToServer (e) {
    e.preventDefault();
    console.log('postToServer');
    const self = this;

    if (this.state.payment.paymentOption === 'instalments') {
      fetchHelpers.postToTransfer(this.state, (response) => {
        let newState = self.state;
        newState.customer.token = response.token;
        if (response.status === 'success' && response.statusCode === 200) {
          newState.currentStep = 4;
          newState.redirect = true;
          this.signupToMailingList(newState.customer);
          window.fbq('track', 'Purchase', {value: newState.course.price, currency: 'GBP'});
        } else {
          newState = this.errorResponseHandler(newState, response);
        }
        self.setState(newState);
        self.forceUpdate();
      });
    } else {
      // Get Stripe.js instance
      const stripe = await stripePromise;

      fetchHelpers.postToCheckout(this.state, async (response) => {
        let newState = self.state;
        newState.customer.token = response.token;
        if (response.status === 'success' && response.statusCode === 200) {

          this.signupToMailingList(newState.customer);

          const result = await stripe.redirectToCheckout({
            sessionId: response.sessionId,
          });

          if (result.error) {
            console.log('result.error.message', result.error.message);
            newState.serverErrorMessage = result.error.message;
          }

        } else {
          newState = this.errorResponseHandler(newState, response);
        }
        self.setState(newState);
        self.forceUpdate();
      });
    }

  }

  handleStepSubmit (stepNumber, stepState) {
    let newState = Object.assign(this.state, stepState);
    newState.serverErrorMessage = '';
    newState.currentStep = stepNumber;
    newState.redirect = true;
    console.log('newState', newState);
    this.setState(newState);
  }

  handleGetStarted () {
    fetchHelpers.redirectToApp(this.state.customer.token);
  }

  componentDidUpdate () {
    if (this.state.redirect) {
      const state = this.state;
      state.redirect = false;
      state.serverError = '';
      this.setState(state);
    }
  }

  async componentDidMount () {
    let inAppPurchase = false;
    let token = '';
    let orderId = '';
    let course = {};
    let serverErrorMessage = '';

    const qsParsed = queryString.parse(window.location.search);

    if (qsParsed.inapppurchase) {
      inAppPurchase = qsParsed.inapppurchase === 'true';
    }
    if (qsParsed.token && qsParsed.token !== '') {
      token = qsParsed.token;
    }
    if (qsParsed.orderid && qsParsed.orderid !== '') {
      orderId = qsParsed.orderid;
      var completeResponse = await fetchHelpers.postToComplete(orderId);
      console.log('completeResponse', completeResponse);
      if (completeResponse.status !== 'success') {
        serverErrorMessage = 'Failed to complete the purchase, please email support@bslcourses.co.uk';
      } else {
        console.log(completeResponse.coursePrice);
        window.fbq('track', 'Purchase', {value: completeResponse.coursePrice, currency: 'GBP'});
      }
    }
    const state = this.state;
    state.inAppPurchase = inAppPurchase;
    state.customer.token = token;
    state.serverErrorMessage = serverErrorMessage;
    this.setState(state);

    var self = this;

    if (qsParsed.courseid && qsParsed.courseid !== '') {
      const newState = self.state;
      graphql.getCourses().then((response) => {
        course = response.courses.find(
          (c) => c.id === parseInt(qsParsed.courseid, 10)
        );
        if (!course || course === null) {
          alert('this course is no longer available');
        } else {
          course.price = course.courseOptions[0].price;
          course.instalmentPrice = course.courseOptions[0].instalmentPrice;
          course.instalmentDurationMonths = course.courseOptions[0].instalmentDurationMonths;
          if (course.category === 'independent') {
            newState.redirect = true;
            newState.currentStep = 2;
          } else if (course.level <= 3) {
            newState.redirect = true;
          }
        }
        newState.course = course;
        newState.courses = response.courses;
        self.setState(newState);
      });
    }
  }

  render () {
    if (this.state.redirect) {
      switch (this.state.currentStep) {
        case 1:
          return <Redirect to='/checkout/payment-type' />;
        case 2:
          return <Redirect to='/checkout/payment-details' />;
        case 3:
          return <Redirect to='/checkout/confirm' />;
        case 4:
          return <Redirect to='/checkout/complete' />;
        default:
          return <Redirect to='/checkout/register' />;
      }
    } else {
      return (
        <div className='l-container l-container--narrow'>
          <Helmet>
            <title>Checkout</title>
          </Helmet>
          <header className='checkout-header'>
            <Link to='/' className='checkout-header__exit'>Cancel and exit checkout</Link>
            <Link to='/' className='branding'>
              <img src={logo} alt='BSLcourses logo' />
            </Link>
            <p className='checkout-header__info'>Need help? <Link to='/contact'>Get in touch</Link></p>
          </header>
          <main className='main checkout'>
            <h1>Secure online checkout - {this.state.course.title}</h1>
            <CheckoutProgress inAppPurchase={this.state.inAppPurchase} course={this.state.course} />
            <CheckoutServerError message={this.state.serverErrorMessage} />
            <Switch>
              <Route path='/checkout/course-option' render={
                () => {
                  return <CourseOption onSubmit={this.handleStepSubmit} checkoutState={this.state} />;
                }
              } />
              <Route path='/checkout/register' render={
                () => {
                  return <Register onSubmit={this.handleStepSubmit} checkoutState={this.state} />;
                }
              } />
              <Route path='/checkout/payment-type' render={
                () => {
                  return <PaymentType onSubmit={this.handleStepSubmit} checkoutState={this.state} />;
                }
              } />
              <Route path='/checkout/payment-details' render={
                () => {
                  return <PaymentDetails onSubmit={this.postToServer} checkoutState={this.state} />;
                }
              } />
              <Route path='/checkout/confirm' render={
                () => {
                  return <Confirm onSubmit={this.handleStepSubmit} checkoutState={this.state} />;
                }
              } />
              <Route path='/checkout/complete' render={
                () => {
                  return <Complete onSubmit={this.handleGetStarted} checkoutState={this.state} />;
                }
              } />
            </Switch>
          </main>
          <footer className='checkout-footer'>
            <a href='https://stripe.com/gb' target='_blank' rel='noopener noreferrer'><img src={stripePower} alt='Powered by Stripe' /></a>
            <p>We accept all major credit and debit cards as well as bank transfer.</p>
            <div className='checkout-footer__bottom'>
              <a href='http://www.signature.org.uk' target='_blank' rel='noopener noreferrer'><img src={signatureLogo} alt='Signature logo' /></a>
              <a href='http://ibsl.org.uk' target='_blank' rel='noopener noreferrer'><img src={ibslLogo} alt='IBSL logo' /></a>
              <p>
                © Copyright 2017 BSLcourses.co.uk Ltd. All rights reserved.
              </p>
            </div>
          </footer>
        </div>
      );
    }
  }
}

Checkout.propTypes = {
  location: PropTypes.object
};

export default Checkout;



// WEBPACK FOOTER //
// ./src/views/Checkout/index.js